"use client";

import { useI18n } from "@wojo/localization";
import { StoryblokImage } from "@wojo/storyblok";
import { Card, Text } from "@wojo/ui";
import cn from "clsx";
import { BasicOldTripFragment } from "generated/graphql";
import React, { useState } from "react";
import { OldTripsModal } from "../old-trips-modal";
import { formatDateRange } from "./TripCard";
import styles from "./TripCard.module.scss";

export type OldTripCardProps = {
    trip: BasicOldTripFragment;
};

export const OldTripCard: React.FC<OldTripCardProps> = ({ trip }) => {
    const i18n = useI18n("account").account;
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Card
                className={cn(styles.card, styles["old-trip-card"])}
                tag="button"
                onClick={() => setIsModalOpen(true)}
            >
                <div className={cn(styles.image, styles["old-trips"])}>
                    <StoryblokImage
                        coverContainer
                        mobile={{
                            asset: {
                                alt: "",
                                filename:
                                    i18n.myTours.tripCard.imagePlaceholder.l(),
                            },
                        }}
                    />
                </div>
                <div className={styles.content}>
                    <div className={styles.body}>
                        {trip.startDate && trip.endDate && (
                            <Text.Detail className={styles["old-trip-text"]}>
                                {formatDateRange(trip.startDate, trip.endDate)}
                            </Text.Detail>
                        )}
                        <Text.Heading
                            order="5"
                            tag="p"
                            className={styles["old-trip-text"]}
                        >
                            {trip.tourInternalName ??
                                i18n.tourNameUnavailableLabel.l()}
                            <span className={styles["focus-ring"]} />
                        </Text.Heading>
                    </div>
                </div>
            </Card>
            <OldTripsModal
                isOpen={isModalOpen}
                onCloseRequested={() => setIsModalOpen(false)}
            />
        </>
    );
};
